import { render, staticRenderFns } from "./LsClickable.vue?vue&type=template&id=e966c9e2&scoped=true&"
import script from "./LsClickable.vue?vue&type=script&lang=js&"
export * from "./LsClickable.vue?vue&type=script&lang=js&"
import style0 from "./LsClickable.vue?vue&type=style&index=0&id=e966c9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e966c9e2",
  null
  
)

export default component.exports